import ConfirmationForm from './ConfirmationForm';

export default ConfirmationForm;
